import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

// Design System - Tema customizado com paleta de cores moderna
const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',

  // Paleta de cores customizada (SenseUp + Original)
  colors: {
    blue: [
      '#E3F2FD', // 0 - lightest
      '#BBDEFB',
      '#90CAF9',
      '#64B5F6',
      '#42A5F5',
      '#2196F3', // 5 - primary
      '#1E88E5',
      '#1976D2',
      '#1565C0',
      '#0D47A1', // 9 - darkest
    ],
    yellow: [
      '#FFF9E6',
      '#FFF3CC',
      '#FFECB3',
      '#FFE599',
      '#FFDF80',
      '#FFD966', // 5 - SenseUp accent
      '#F4C542',
      '#E0B030',
      '#CC9C1F',
      '#B8880E',
    ],
  },

  // Tipografia
  headings: {
    fontWeight: '600',
    sizes: {
      h1: { fontSize: '32px', lineHeight: '1.2' },
      h2: { fontSize: '24px', lineHeight: '1.3' },
      h3: { fontSize: '20px', lineHeight: '1.4' },
      h4: { fontSize: '18px', lineHeight: '1.4' },
    },
  },

  fontSizes: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '24px',
  },

  // Espaçamentos
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  // Border radius
  radius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
  },

  // Sombras
  shadows: {
    xs: '0 1px 3px rgba(0, 0, 0, 0.05)',
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.12)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.15)',
    xl: '0 16px 32px rgba(0, 0, 0, 0.2)',
  },

  // Configurações de componentes
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Modal: {
      defaultProps: {
        radius: 'lg',
        transitionProps: { transition: 'fade', duration: 200 },
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
        shadow: 'sm',
      },
    },
  },

  // Outros ajustes
  defaultRadius: 'md',
  focusRing: 'auto',
  cursorType: 'pointer',
});

function App() {
  return (
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <Notifications position="top-right" />
        <RouterProvider router={router} />
      </ModalsProvider>
    </MantineProvider>
  );
}

export default App;
